var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalSelectedEmployeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 18V17.2609C1.25 15.6926 1.84702 14.1886 2.90973 13.0797C3.97243 11.9708 5.41377 11.3478 6.91667 11.3478H8.33333C9.83623 11.3478 11.2776 11.9708 12.3403 13.0797C13.403 14.1886 14 15.6926 14 17.2609V18M11.1667 4.69565C11.1667 5.6758 10.7935 6.6158 10.1293 7.30887C9.46515 8.00194 8.56431 8.3913 7.625 8.3913C6.68569 8.3913 5.78485 8.00194 5.12066 7.30887C4.45647 6.6158 4.08333 5.6758 4.08333 4.69565C4.08333 3.7155 4.45647 2.7755 5.12066 2.08243C5.78485 1.38936 6.68569 1 7.625 1C8.56431 1 9.46515 1.38936 10.1293 2.08243C10.7935 2.7755 11.1667 3.7155 11.1667 4.69565Z",
    stroke: "#145DFD",
    strokeWidth: 1.45067,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalSelectedEmployeeIcon);
export default __webpack_public_path__ + "static/media/TotalSelectedEmployeeIcon.cc2f230a7077f46e9da849313ef8a1c4.svg";
export { ForwardRef as ReactComponent };